import React, { useEffect, useRef } from "react";
import { isWeb } from "../platform";
import { generateTypographyCSS } from "./typography-css";

let injected = false;

/**
 * Injects responsive typography CSS custom properties into the document.
 * Safe to render multiple times — the style tag is only created once.
 * No-ops on React Native.
 *
 * Injected CSS includes :root variables for all font-size and line-height
 * scale steps, plus @media overrides for mobile breakpoints.
 *
 * @see {@link ./typography-css.ts} for the generated CSS content
 */
function injectTypographyStyles(): void {
  if (!isWeb || injected) return;

  const style = document.createElement("style");
  style.setAttribute("data-xui-typography", "");
  style.textContent = generateTypographyCSS();
  document.head.appendChild(style);
  injected = true;
}

export const TypographyStyleLoader: React.FC = () => {
  const mountedRef = useRef(false);

  useEffect(() => {
    if (!mountedRef.current) {
      injectTypographyStyles();
      mountedRef.current = true;
    }
  }, []);

  return null;
};

TypographyStyleLoader.displayName = "TypographyStyleLoader";
